import React, { useState } from 'react'
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Space } from 'antd';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;


const PaymentProcessApproveReject = () => {
    const title = "Approve/Reject Payment Process by SOM";
    const navigate = useNavigate();
    const [IsConfirmModalOpen, SetIsConfirmModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [IsApprove, SetIsApprove] = useState(false)

    const _doNavToPaymentListSOM = () => {
        navigate('/PaymentInvoiceProcessSOM');
    }
    const _doOpenRejectModal = () => {
        SetIsConfirmModalOpen(true)
        setIsModalOpen(true)
        SetIsApprove(false)
    }
    const _doOpenConfirmModal = () => {
        SetIsConfirmModalOpen(true)
        setIsModalOpen(true)
        SetIsApprove(true)
    }
    const _doCloseConfirmModal = () => {
        SetIsConfirmModalOpen(false)
        setIsModalOpen(false)
        SetIsApprove(false)
    }

    const _doSelectVender = () => {

    }

    const TableData = [
        {
            key: '1',
            BudgetCategory: "Preventive Maintainance",
            AssetCategory: "Electrical ",
            TotalAmount: "10100"
        },
        {
            key: '2',
            BudgetCategory: "Corrective Maintainance",
            AssetCategory: "Electrical ",
            TotalAmount: "10100"
        },
        {
            key: '2',
            BudgetCategory: "Corrective Maintainance",
            AssetCategory: "Electrical ",
            TotalAmount: "10100"
        },
        {
            key: '3',
            BudgetCategory: "Corrective Maintainance",
            AssetCategory: "Electrical ",
            TotalAmount: "10100"
        }

    ]
    const TableColumns = [
        {
            title: "Budget Category",
            dataIndex: "BudgetCategory",
            key: "BudgetCategory"
        },
        {
            title: "Asset Category",
            dataIndex: "AssetCategory",
            key: "AssetCategory"
        },
        {
            title: "Total Amount",
            dataIndex: "TotalAmount",
            key: "TotalAmount"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i className="fa fa-trash-o text-danger"></i>
                    </div>
                </Space>
            ),
        }

    ]

    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            {
                IsConfirmModalOpen === true ?
                    <Modal
                    open={isModalOpen} title="Confirmation"

                        footer={[
                            <div className="">
                                <button type='button' onClick={_doCloseConfirmModal} className='btn muted-button  deca-btn-orange btn-m-right'>Cancel</button>
                                <button type='button' onClick={_doCloseConfirmModal} className='btn btn-secondary  deca-btn-yellow'>Ok</button>
                            </div>
                        ]}
                    >
                        {
                            IsApprove === true ?
                                <div className="">
                                    <h5>Are you sure you want to Approve & Process for Payment</h5>
                                </div>
                                : <div className="">
                                    <h5>Are you sure you want to Reject</h5>
                                </div>
                        }

                    </Modal> : null

            }
            <div className='content-wrapper'>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="m-paymentdetails">
                                    <div className="paymentheader">
                                        <span className="vendorPayment_header">Vendor Payment Details</span>
                                        <span>Status : <label className="pending_status">Pending</label></span>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Vendor Name* </label>
                                                <label className="content_label col-md-6">Name</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">GST Number* </label>
                                                <label className="content_label col-md-6">GTIN9204092333</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Decatholon GST Number* </label>
                                                <label className="content_label col-md-6">GTIN9204092333</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Decatholon Third Code* </label>
                                                <label className="content_label col-md-6">82342384392</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Contract Name* </label>
                                                <label className="content_label col-md-6">1060-Vendor-AMC</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Vendor GST Number* </label>
                                                <label className="content_label col-md-6">GTIN2942107489</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">HSN/SAC Number* </label>
                                                <label className="content_label col-md-6">HSN902148924</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Nature of Service*</label>
                                                <label className="content_label col-md-6">Simple</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Contract End Date* </label>
                                                <label className="content_label col-md-6">11-11-2021</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Invoice Number* </label>
                                                <label className="content_label col-md-6">12242</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Invoice Date* </label>
                                                <label className="content_label col-md-6">5-Jun-20</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Amount* </label>
                                                <label className="content_label col-md-6">20000</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">GST*(%) </label>
                                                <label className="content_label col-md-6">18%</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">GST Value* </label>
                                                <label className="content_label col-md-6">3600</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Total Amount* </label>
                                                <label className="content_label col-md-6">23600</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-paymentdetails-form">
                                    <div className="paymentheader">
                                        <h4 className="vendorPayment_header">Verify Payment Details</h4>
                                        <span className="item_label text-danger">Note* : As per the invoice value, to add the below multiple line items wise for verification</span>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="exampleInput">Budget Category*</label>
                                                <Select className="form-control"
                                                    showSearch
                                                    onChange={_doSelectVender}
                                                    placeholder="-- Please Select --"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    <Option value='1'>Prevantive Maintaince</Option>
                                                    <Option value='2'>Corrective Maintaince</Option>
                                                    <Option value='3'>Third Part Verification</Option>
                                                    <Option value='4'>Annual Expense</Option>
                                                    <Option value='5'>Annual Investment</Option>
                                                    <Option value='6'>House Keeping</Option>
                                                    <Option value='7'>Security</Option>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="exampleInput">Asset Main Category</label>
                                                <Select className="form-control"
                                                    showSearch
                                                    onChange={_doSelectVender}
                                                    placeholder="-- Please Select --"
                                                    optionFilterProp="children">
                                                    <Option value="1">Category 1</Option>
                                                    <Option value="2">Category 2</Option>
                                                    <Option value="3">Category 3</Option>
                                                    <Option value="4">Category 4</Option>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="exampleInput">Asset Sub Category</label>
                                                <Select className="form-control"
                                                    showSearch
                                                    onChange={_doSelectVender}
                                                    placeholder="-- Please Select --"
                                                    optionFilterProp="children">
                                                    <Option value="1">Category 1</Option>
                                                    <Option value="2">Category 2</Option>
                                                    <Option value="3">Category 3</Option>
                                                    <Option value="4">Category 4</Option>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='exampleInput'>Amount(Excluding GST)*</label>
                                                <input type="text" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='exampleInput'>Remarks</label>
                                                <input type="text" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <button type="submit" className="btn btn-secondary deca-btn-yellow add">Add</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="m-table__main">
                                        <div className="m-table__responsive medium-width">
                                        <Table
                                                columns={TableColumns}
                                                dataSource={TableData}
                                                pagination={false}
                                                scroll={{ y: 300 }}
                                                bordered
                                                summary={ (pageData)  => {
                                                    let TotAmount= 0;
                                                    pageData.forEach(({ TotalAmount}) => {
                                                        TotAmount += Number(TotalAmount);
                                                    });
                                                    return (
                                                        <Table.Summary fixed> 
                                                            <Table.Summary.Row>
                                                                <Table.Summary.Cell colSpan={2}>Total</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={1}>{TotAmount}</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={1}></Table.Summary.Cell>
                                                            </Table.Summary.Row>
                                                        </Table.Summary>
                                                    )
                                                }}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-right p10">
                                    <button type="submit" onClick={_doOpenRejectModal} className="btn muted-button deca-btn-orange reject">Reject</button>
                                    <button type="submit" onClick={_doOpenConfirmModal} className="btn btn-secondary deca-btn-yellow">Approve & Process for Payment</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <div className="m-page__button top-space">
                                <button type='button' className='btn muted-button  deca-btn-orange' onClick={_doNavToPaymentListSOM}>Back</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default PaymentProcessApproveReject